import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile } from '@cp/ds/src/hooks';
import { Box } from '@cp/ui';
import { Stack } from '@mui/material';
import { BFC } from '../model/types';

export interface PIC {
  heading: string;
  content: string;
}

export const PrimaryInfoContent: BFC<PIC> = ({ content, heading, sx }) => {
  const isMobile = useIsMobile();
  return (
    <Stack>
      <Typography component="h2" sx={{ mt: 0, mb: isMobile ? 1.5 : 5, ...sx }} variant="h2">
        {heading}
      </Typography>
      <Box dangerouslySetInnerHTML={{ __html: content }} sx={{ my: '-16px' }} />
    </Stack>
  );
};
